export default __webpack_public_path__ + "static/media/ngn.fa309a63.svg";